import { Divider } from 'antd';
import React from 'react'

const DividerLine = () => {
  return <Divider className='m-0 my-3' style={{boxShadow: "0.1px 0.1px 1.9px #000"}} />;
}

export default DividerLine